import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { CompanyStoreService } from '@fleet-beat/shared';
import { filter, map, Observable, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyReadyGuard implements CanActivate {
  constructor(private companyStore: CompanyStoreService) {}

  canActivate(): Observable<boolean> {
    return this.companyStore.onCompany().pipe(
      filter(Boolean),
      take(1),
      map(() => {
        return true;
      }),
    );
  }
}
